import { Main } from './components';

const Users = () => <Main />;

export default Users;

